<template>
  <div class="d-flex w-100 overflow">
    <div class="overflow-scroll p-1">
      <chat-header :title="$t('ia.chat.techchat5')" :sidebar_layout="sidebar_layout"
        :should_show_buttons="should_show_buttons" @toggle-menu="$emit('slide_window')"
        @toggle-layout="toggleLayoutChatHeader" @new-chat="startNewChat()" />

      <div class="h-100 flex-grow" ref="main-container-chat">
        <div class="default-conversation" v-if="Object.keys(conversation_selected).length === 0">
          <div class="sender mb-2" :class="{ 'receiver': i === 2 }" v-for="i in 3" :key="i"
            :style="`opacity: ${1 - 0.23 * i}`">
            <div class="avatar"></div>
            <div class="w-100 ml-2" :class="{ 'd-flex flex-column align-items-end mr-2': i === 2 }">
              <div class="title-conversation"></div>
              <div class="message-bubble"></div>
            </div>
          </div>
        </div>

        <div class="conversation-chat" v-if="Object.keys(conversation_selected).length > 0">
          <chat-message-bubble 
            v-for="(msg, index) in conversationMessages" 
            :key="index" 
            :role="msg.role"
            :content="msg.content" 
            :messageType="msg.type" 
            :isLoading="msg.is_loading" 
            :avatars="{
              user: image_profile,
              assistant: assistantToSidebar
            }" 
            @copy="copyAction(msg.content)" 
            @download="downloadAllFiles">
            <template #actions v-if="msg.role === 'assistant' && !msg.is_loading">
              <chat-message-actions 
                v-if="!isAssistantSection"
                        :message-type="msg.type" :has-original-message="msg.original_message !== undefined"
                        :actions="actionsMessageComputed" :credits="{
                  actions: getCredits('actions_message'),
                  images: getCredits('images_message')
                }" 
                @action="actionMessage($event, msg)" 
                @export="message_selected = msg; sidebar_export_chat = true;"
                @generate-image="actionMessage('generate_image', msg)" @download-all="downloadAllFiles(msg.content)"
                @generate-more="actionMessage('generate_image', msg)" />
            </template>
          </chat-message-bubble>
        </div>
      </div>

      <chat-input v-model="query" :placeholder="placeholder_text" :loading="loader_chat" @send="chat()"
        @focus="onFocusInputSearch()" @blur="onBlurInputSearch()">
        <template #credits>
          <b-badge class="badge-button-ia">
            {{ getCredits() >= 0 ? getCredits() : $t('ia.general.insufficientCredits') }}
          </b-badge>
        </template>
      </chat-input>
    </div>

    <b-card class="card-chat-history h-100 d-none d-xl-block" v-if="sidebar_layout">
      <chat-history-panel :conversations="conversations"
        :selected-index="selectedIndex" :is-editing="is_editing_title" :title-value="title_chat"
        :assistant="assistantToSidebar" :loading="loading_conversations" @new-chat="startNewChat()"
        :key="update_history_panel"
        @select="openConversation" @edit="editTitle($event)"
        @confirm="editTitleAction" @cancel="cancelEdit($event)"
        @not-edit-title="is_editing_title = false"
        @title-input="title_chat = $event" @redirect-explore-assistants="$emit('redirect-explore-assistants')"
        @toggle-layout="sidebar_layout = !sidebar_layout"
        @open-persona-switcher="show_persona_switcher = true; update_sidebar = !update_sidebar" />
    </b-card>

    <b-sidebar v-model="sidebar_layout_responsive" backdrop shadow right
      class="d-xl-none sidebar-responsive-layout-chats">
      <div class="p-1 card-chat-history h-100">
        <chat-history-panel :conversations="conversations"
          :selected-index="selectedIndex" :is-editing="is_editing_title" :title-value="title_chat"
          :assistant="assistantToSidebar" :loading="loading_conversations" @new-chat="startNewChat(); sidebar_layout_responsive = false"
          :key="update_history_panel"
          @select="openConversation"
          @edit="editTitle($event)" @confirm="editTitleAction"
          @not-edit-title="is_editing_title = false"
          @cancel="cancelEdit($event)" @title-input="title_chat = $event"
          @toggle-layout="sidebar_layout_responsive = !sidebar_layout_responsive"
          @open-persona-switcher="show_persona_switcher = true; update_sidebar = !update_sidebar;"

        />
      </div>
    </b-sidebar>

    <b-sidebar v-model="sidebar_export_chat" backdrop shadow right no-header>
      <chat-export-sidebar @export="exportMessageAction(message_selected, $event)" @close="sidebar_export_chat = false"/>
    </b-sidebar>

    <!-- Persona Switcher Sidebar -->
    <b-sidebar v-model="show_persona_switcher" backdrop no-header right class="persona-switcher-sidebar-container">
      <persona-switcher-sidebar :assistant="data_settings.person_assistant"
        @update-settings="$emit('update-settings', $event)" @navigate-to-explore="$emit('redirect-explore-assistants')"
        @close-switcher="show_persona_switcher = $event"
        v-if="show_persona_switcher" />
    </b-sidebar>
  </div>
</template>

<script>

import {
  BBadge,
  BCard,
  BSidebar,
} from 'bootstrap-vue';
import { nextTick } from '@vue/composition-api';
import config from '@/services/config';
import { getUserData } from '@/libs/utils/user';
import { downloadFile, showToast } from '@/libs/utils/others';
import { verifyAsset } from '@/libs/utils/urls';
import { toSnakeCase } from '@/libs/utils/formats';
import { chat, actionsMessage, getConversations, editTitleChat, exportMessage, getPriceActions, getSocialTexts, generateText, recentlyUsed } from '@/services/ia-refactored';

export default {
  name: 'chat',
  components: {
    BBadge,
    BCard,
    BSidebar,
    ChatHeader: () => import('./chat/ChatHeader.vue'),
    ChatMessageBubble: () => import('./chat/ChatMessageBubble.vue'),
    ChatMessageActions: () => import('./chat/ChatMessageActions.vue'),
    ChatInput: () => import('./chat/ChatInput.vue'),
    ChatHistoryPanel: () => import('./chat/ChatHistoryPanel.vue'),
    ChatExportSidebar: () => import('./chat/ChatExportSidebar.vue'),
    PersonaSwitcherSidebar: () => import('./chat/PersonaSwitcherSidebar.vue'),
  },
  data() {
    return {
      verifyAsset,
      downloadFile,
      image_profile: this.getImgProfile(getUserData().profile_image),
      loader_chat: false,
      loading_conversations: false,
      update_history_panel: 0,
      conversations: [],
      conversation_selected: {},
      placeholder_text: '',
      query: '',
      cancel_token_estimated: null,
      axios: null,
      estimated_credits: 0,
      estimated_credits_loaded: 0,
      is_editing_title: false,
      title_chat: '',
      timeout: null,
      sidebar_layout: true,
      sidebar_layout_responsive: false,
      user: '',
      is_focus: false,
      actions_message_defs: [
        { textKey: 'ia.chat.rephrase', value: 'rephrase' },
        { textKey: 'ia.chat.elaborate', value: 'elaborate' },
        { textKey: 'ia.chat.summarize', value: 'summarize' },
        { textKey: 'ia.chat.regenerate', value: 'regenerate' },
      ],
      message_selected: null,
      actions_message_credit: null,
      images_message_credit: null,
      sidebar_export_chat: false,
      show_persona_switcher: false,
      selectedIndex: null,
      time_per_char: 10,
      full_text: '',
      i: 0,
      window_width: window.innerWidth,
      update_sidebar: false,
      typewriter_timeout: null,
    }
  },
  props: {
    credits_avaible: {
      type: Number,
      default: 0
    },
    data_settings: {
      type: Object,
      default: () => ({
        person_assistant: {}
      })
    }
  },
  computed: {
    // For responsive purposes
    should_show_buttons() {
      return this.window_width >= 1200 ? !this.sidebar_layout : true;
    },
    isAssistantSection() {
      return this.$route.params.section === 'assistants';
    },
    assistantToSidebar() {
      if (!this.$route.params.uuid) return this.data_settings?.person_assistant;
      else if (this.$route.params.uuid && this.conversation_selected.person_assistant) return this.conversation_selected.person_assistant;
      else if (this.$route.params.uuid && !this.conversation_selected.person_assistant) return null;
      return null;
    },
    conversationMessages() {
      return this.conversation_selected.messages.filter((msg) => msg.role !== 'system');
    },
    getAssistantActive() {
      return this.conversation_selected?.person_assistant?.uuid ?? this.data_settings?.person_assistant?.uuid ?? undefined;
    },
    actionsMessageComputed() {
      return this.actions_message_defs.map(def => ({
        text: this.$t(def.textKey),
        value: def.value
      }));
    },
  },
  async mounted() {

    this.startAnimation();
    this.axios = (await import('axios')).default;
    const params = this.$route.params;
    this.loading_conversations = true;

    setTimeout(() => {
      if (params.section === 'assistants')
        this.getTextsHistory();
      else if (params.section === 'chat')
        this.getConversations();

      this.getPriceActions();
    }, 1000);
    window.addEventListener('resize', this.handleResize);
  },
  created() {
    const handleResponse = (data) => {
      this.i = 0;
      this.loader_chat = false;
      
      // Update conversations array first
      const index = this.conversations.findIndex(i => i.uuid === data.body.uuid);
      if (index !== -1) {
        this.conversations[index] = data.body;
      }
      
      this.conversation_selected = this.conversations[index] || data.body;
      this.full_text = this.conversation_selected.messages[this.conversation_selected.messages.length - 1].content;
      this.conversation_selected.messages[this.conversation_selected.messages.length - 1].content = '';
      this.typeWriterEffect();
      
      this.$emit('update_credits', this.estimated_credits_loaded);
      this.$root.$emit('update_credits_drop', this.estimated_credits_loaded)
      setTimeout(() => {
        nextTick(() => { this.scrollToBottomInChatLog() })
      }, 1)
    };

    this.$root.$on('chatgpt_response_ws', handleResponse);
    this.$root.$on('social_text_response', handleResponse);
  },
  beforeDestroy() {
    this.stopTypeWriterEffect();
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getTextsHistory() {
      getSocialTexts({ type_text: toSnakeCase(this.$route.params.category) }).then(({response}) => {
        this.conversations = response.results;
        const chat_uuid = this.$route.params.uuid;

        if (chat_uuid) { 
          const index = this.conversations.findIndex(chat => chat.uuid === chat_uuid);
          this.selectedIndex = index;
          this.$nextTick(() => {
            this.scrollToBottomInChatLog();
          });

          this.openConversation(this.conversations.find(chat => chat.uuid === chat_uuid), index);
        }
      }).finally(() => {
        this.loading_conversations = false;
      }).catch(() => {
        this.loading_conversations = false;
        showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.getConversations'));
      });
    },
    closeSwitcher(val) {
      this.show_persona_switcher = val;
    },
    handleResize() {
      this.window_width = window.innerWidth;
    },
    toggleLayoutChatHeader() {
      if (this.window_width >= 1200) {
        this.sidebar_layout = !this.sidebar_layout;
      } else {
        this.sidebar_layout_responsive = !this.sidebar_layout_responsive;
      }
    },
    typeWriterEffect() {
      if (this.i <= this.full_text.length) {
        this.i++;
        this.conversation_selected.messages[this.conversation_selected.messages.length - 1].content = this.full_text.slice(0, this.i);
        nextTick(() => { this.scrollToBottomInChatLog() });
        this.typewriter_timeout = setTimeout(this.typeWriterEffect, this.time_per_char);
      }
    },
    stopTypeWriterEffect() {
      if (this.typewriter_timeout) {
        clearTimeout(this.typewriter_timeout);
        this.typewriter_timeout = null;
      }
    },
    getPriceActions() {
      getPriceActions().then(({response}) => {
        this.actions_message_credit = response.action_on_message;
        this.images_message_credit = response.generate_images;
      })
    },
    actionMessage(action, message) {
      this.loader_chat = true;
      this.estimated_credits_loaded = (action === 'generate_image') ? this.images_message_credit : this.actions_message_credit;
      const data = {
        action,
        message: message.type === 'images' ? message.original_message : message.content || message,
        chat_uuid: this.conversation_selected.uuid
      }
      this.conversation_selected.messages = [...this.conversation_selected.messages, { role: 'assistant', is_loading: true, content: '', type: action === 'generate_image' ? 'images' : undefined }];
      this.$nextTick(() => { this.scrollToBottomInChatLog() });
      
      actionsMessage(data).then(() => { 
      }).catch(() => {
        this.loader_chat = false;
        this.conversation_selected.messages.pop();
        showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.gettingResponse'))
      });
    },
    recentlyUsedText() {
      const slug = this.$route.params.category;
      const data = { name: slug, slug };
      recentlyUsed(data).then(({response}) => {
        this.$emit('update-settings', response);
      })
    },
    exportMessageAction(message, type_export) {
      const data = {
        type_export,
        message: message.content || message,
        chat_uuid: this.conversation_selected.uuid
      }
      exportMessage(data).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.conversation_selected.title}.${type_export === 'doc' ? 'docx' : 'txt'}`);
        document.body.appendChild(link);
        link.click();
        this.sidebar_export_chat = false;
      }).catch(() => {
        showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.gettingResponse'))
      });
    },
    downloadAllFiles(files) {
      files.forEach(file => {
        downloadFile(file);
      });
    },
    onFocusInputSearch() {
      this.is_focus = true;
      this.placeholder_text = '';
    },
    onBlurInputSearch() {
      this.is_focus = false;
      this.startAnimation();
    },
    startAnimation() {
      const placeholder_text = this.$t('creator.sendMessage');
      const speed = 50;
      this.animatePlaceholder(placeholder_text, speed);
    },
    getCredits(actions_message = 'message') {
      if (actions_message === 'message') return this.credits_avaible >= this.estimated_credits ? this.estimated_credits : -1;
      else if (actions_message === 'actions_message') return this.credits_avaible >= this.actions_message_credit ? this.actions_message_credit : -1;
      else if (actions_message === 'images_message') return this.credits_avaible >= this.images_message_credit ? this.images_message_credit : -1;
    },
    getImgProfile(image_url) {
      if (image_url !== null && image_url !== "")
        return verifyAsset(image_url);
      const img = require(`@/assets/images/avatars/${
        Math.floor(Math.random() * 4) + 1
      }.png`);
      return img;
    },
    async typeWriter(text, index, speed) {
      if (index < text.length && !this.is_focus) {
        this.placeholder_text += text.charAt(index);
        await this.sleep(speed);
        await this.typeWriter(text, index + 1, speed);
      }
    },
    async animatePlaceholder(text, speed) {
      this.placeholder_text = '';
      await this.typeWriter(text, 0, speed);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    startNewChat() {
      this.stopTypeWriterEffect();
      this.conversation_selected = {};
      this.selectedIndex = null;
      this.full_text = '';
      this.query = '';
      this.$router.push({ name: 'brandme_AI', params: { section: this.$route.params.section, category: this.$route.params.category } }).catch(() => { });
    },
    generateTextMethod() {
      this.estimated_credits_loaded = this.estimated_credits;
      const data = {
        type_text: toSnakeCase(this.$route.params.category),
        prompt: this.query,
        person_assistant_uuid: this.getAssistantActive,
        prev_text: this.conversation_selected.uuid || undefined
      };
      this.query = '';

      generateText(data).then(({response}) => {
        if (!this.conversations.find(i => i.uuid === response.uuid)) {
          // Add assign messages when there is new the chat
          if (!this.conversation_selected.uuid) {
            response.messages = this.conversation_selected.messages;
          }
          
          // Find first message with role 'user' for the title
          const firstUserMessage = response.messages.find(msg => msg.role === 'user');
          response.title = firstUserMessage ? firstUserMessage.content : response.messages[0].content;
          
          this.conversations.unshift(response);


          setTimeout(() => {
            this.openConversation(response, 0)
          }, 100);
        }
        
      }).catch(() => {
        this.loader_chat = false;
        this.conversation_selected.messages.pop();
        this.conversation_selected.messages.pop();
        showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.gettingResponse'))
      });

      this.recentlyUsedText();
    },
    estimationCredits() {
      const CancelToken = this.axios.CancelToken;
      if (this.cancel_token_estimated) this.cancel_token_estimated()
      const self = this;
      this.axios({
        method: 'post',
        url: `${config.urlCore}/api/v3/ai/estimated-credits/`,
        data: {
          text: this.query,
          model: 'gpt-3.5-turbo'
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        cancelToken: new CancelToken(function executor(c) {
          self.cancel_token_estimated = c;
        })
      }).then((response) => {
        this.estimated_credits = response.data.response.estimated_credits;
      })
    },
    chat() {
      this.estimated_credits_loaded = this.estimated_credits;
      // If there is a conversation selected, add the message to it


      if (!this.conversation_selected.messages) {
        this.conversation_selected.messages = [];
      }
      if (this.getAssistantActive && !this.conversation_selected.messages) {
        this.conversation_selected = {
          messages: [{ role: 'system', content: '' }],
          person_assistant: {name: ''}
        };
      } 

      if (this.$route.params.section !== 'chat') this.conversation_selected.type_text = this.$route.params.category;
      this.conversation_selected.messages = [...this.conversation_selected.messages, { role: 'user', content: this.query }, { role: 'assistant', is_loading: true, content: '' }];

      this.loader_chat = true;

      // Check if we are in chat or assistant section to change the web service called
      if (this.$route.params.section === 'chat') {
        const data = {
          model: 'gpt-3.5-turbo',
          text: this.query,
          prev_chat: this.conversation_selected.uuid,
          person_assistant_uuid: !this.conversation_selected.uuid ? this.getAssistantActive : undefined
        }
        this.query = '';

        chat(data).then((response) => {
          if (!this.conversations.find(i => i.uuid === response.uuid)) {
            if (!this.conversation_selected.uuid) {
              response.messages = this.conversation_selected.messages;
            }
            // Find first message with role 'user' for the title
            const firstUserMessage = response.messages.find(msg => msg.role === 'user');
            response.title = firstUserMessage ? firstUserMessage.content : response.messages[0].content;

            this.conversations.unshift(response)
            setTimeout(() => {
              this.openConversation(response, 0)
            }, 100);
          }
        }).catch(() => {
          this.loader_chat = false;
          this.conversation_selected.messages.pop();
          this.conversation_selected.messages.pop();
          showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.gettingResponse'))
        });
      } else {
        this.generateTextMethod();
      }
    },
    getConversations() {
      getConversations({}).then((response) => {
        this.conversations = response.response.results;
        const chat_uuid = this.$route.params.uuid;

        if (chat_uuid) {
          const index = this.conversations.findIndex(chat => chat.uuid === chat_uuid);
          this.selectedIndex = index;
          this.$nextTick(() => { this.scrollToBottomInChatLog() });

          this.openConversation(this.conversations.find(chat => chat.uuid === chat_uuid), index);
        }
      }).finally(() => {
        this.loading_conversations = false;
      }).catch(() => {
        this.loading_conversations = false;
        showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.getConversations'));
      });
    },
    openConversation(conversation, index) {
      // If the user changes from conversation while the typewriter effect is happening, stop it and assign the full text saved
      if (this.full_text.length > 0) {
        this.conversation_selected.messages[this.conversation_selected.messages.length - 1].content = this.full_text;
        this.full_text = '';
      }
      this.update_history_panel += 1;
      this.stopTypeWriterEffect();

      this.$router.push({ name: 'brandme_AI', params: { section: this.isAssistantSection ? 'assistants' : 'chat', category: this.isAssistantSection ? this.$route.params.category : 'chat-gpt', uuid: conversation.uuid } }).catch(() => { })
      this.conversation_selected = conversation;
      this.selectedIndex = index;
      setTimeout(() => {
        nextTick(() => { this.scrollToBottomInChatLog() })
      }, 100);
    },
    editTitle(index) {
      this.is_editing_title = true;
      this.title_chat = this.conversations[index].title;
    },
    cancelEdit() {
      this.is_editing_title = false;
    },
    editTitleAction(chat) {
      editTitleChat(chat.uuid, { title: this.title_chat }).then(({response}) => {
        chat.title = response.title;
        this.is_editing_title = false;
      }).catch(() => {
        showToast(this, 'danger', 'XCircleIcon', this.$t('ia.errors.errorUpdateTitle'));
      });
    },
    scrollToBottomInChatLog() {
      const main_container = this.$refs['main-container-chat'];
      if (main_container) main_container.scrollTop = main_container.scrollHeight;
    },
    copyAction(msg) {
      this.$copyText(msg).then(() => {
        showToast(this, 'success', 'CopyIcon', this.$t('ia.chat.msjCopy'));
      });
    },
  },
  watch: {
    query(val) {
      if (val) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.estimationCredits(), 300);
      } else if (val === '') this.estimated_credits = 0;
    },
    '$route.params.category'(newCategory, oldCategory) {
      if (newCategory && newCategory !== oldCategory && this.$route.params.section === 'assistants') {
        this.conversation_selected = {};
        this.selectedIndex = null;
        this.getTextsHistory();
      }
    },
    '$i18n.locale'() {
      this.startAnimation();
    }
  }
}
</script>
<style>
.sidebar-responsive-layout-chats>.b-sidebar {
  width: 430px;
}

.persona-switcher-sidebar-container>.b-sidebar {
  background-color: white !important;
  width: 430px;
}
</style>
<style lang="scss" scoped>
.overflow {
  height: 100%;
}

.default-conversation {
  width: 100%;

  .sender {
    display: flex;
    width: 100%;

    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 100%;
      background-color: #E9ECEF;
      flex-shrink: 0;
    }

    .title-conversation {
      width: 110px;
      height: 20px;
      margin-bottom: 0.4em;
      background-color: #E9ECEF;
    }

    .message-bubble {
      width: 95%;
      height: 115px;
      background-color: #e9ecef;
      border-radius: .5em;
      position: relative;

      &::before {
        border: 10px solid#e9ecef;
        content: '';
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-right-color: transparent;
        position: absolute;
        left: -10px;
      }
    }
  }

  .receiver {
    flex-direction: row-reverse;

    .message-bubble {
      &::after {
        border: 10px solid #e9ecef !important;
        content: '' !important;
        border-left-color: transparent !important;
        border-bottom-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent;
        position: absolute !important;
        right: -10px !important;
      }

      &::before {
        border: 10px solid transparent !important;
        content: '' !important;
      }
    }
  }
}

.flex-grow {
  flex-grow: 1;
  overflow-y: scroll;
  overflow-x: hidden;
}

.conversation-chat {
  width: 100%;
  height: 100% !important;
}

.overflow-scroll {
  height: 100%;
  overflow-x: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-chat-history {
  flex-shrink: 0;
  margin: 0;
  overflow-y: scroll;
  width: 400px;
  max-width: 400px;
}

.badge-button-ia {
  display: flex;
  align-items: center;
  background-color: #40736E;

  .icon-ia {
    width: 14px;
    height: 14px;
    margin-right: 0.2em;
  }
}
</style>
